<template>
    <div>
        <b-row>
            <b-col md="8" lg="8">
                <b-form-group
                    :label="productNameLabel"
                    label-for="name"
                >
                    <b-form-input
                        id="name"
                        class="input-bg-warning"
                        v-model="name"
                        :state="nameState"
                        @input="emit"
                    />
                </b-form-group>
            </b-col>
            <b-col>
                <h6>{{ $t('Page(ReceivedRequest):Component(Text):product-name-in-request') }}</h6>
                <span>{{ customerProduct.name }}</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="8" lg="8">
                <b-form-group
                    :label="productIdLabel"
                    label-for="id"
                >
                    <b-form-input
                        id="id"
                        v-model="id"
                        @input="emit"
                    />
                </b-form-group>
            </b-col>
            <b-col>
                <h6>{{ $t('Page(ReceivedRequest):Component(Text):product-id-in-request') }}</h6>
                <span>{{ customerProduct.identifier }}</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="8" lg="8">
                <b-form-group
                    :label="suppliersScipNumberLabel"
                    label-for="suppliers-scip-number"
                >
                    <b-form-input
                        id="suppliers-scip-number"
                        v-model="suppliersScipNumberId"
                        @input="emit"
                    />
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {BFormInput, BFormGroup, BCol, BRow} from 'bootstrap-vue'
import ReplyTabProductSection from "@core/mixins/ui/reply-tab-product-section";
import ProductCategoryTagView from "@core/components/product/ProductCategoryTagView";
import {setNameOrId, ProductNames, ProductIdentifiers, ProductType} from "@/libs/product";

export default {
    mixins: [ReplyTabProductSection],
    components: {
        BFormInput, BFormGroup, BCol, BRow, ProductCategoryTagView,
    },
    props: {
        product: {
            required: true,
        },
        request: {
            required: true,
        },
        customerProduct: {
            required: true
        },
    },
    data() {
        return {
            name: this.getProductName(this.product.names, this.resolveProductNameKey()),
            id: this.getProductId(this.product.identifiers, this.resolveProductIdentifierKey()),
            suppliersScipNumberId: this.getProductId(this.product.identifiers, ProductIdentifiers.SUPPLIERS_SCIP_NUMBER),

            selected: [
                { title: 'Square' },
                { title: 'Romboid' },
            ],

            type: ProductType.UNDEFINED,
            typeOwn: ProductType.OWN,
            typePurchased: ProductType.PURCHASED_UNDEFINED_SUPPLIER,

            hierarchy: {children: []},
        };
    },
    methods: {
        emit() {
            setNameOrId(
                this.product.names,
                this.resolveProductNameKey(),
                this.name
            );
            setNameOrId(
                this.product.identifiers,
                this.resolveProductIdentifierKey(),
                this.id
            );
            setNameOrId(
                this.product.identifiers,
                ProductIdentifiers.SCIP_NUMBER,
                this.suppliersScipNumberId,
            );

            this.$emit('change');
            this.emitValidity();
        },

        resolveProductNameKey() {
            return ProductNames.OUR_PRODUCT_NAME;
        },

        resolveProductIdentifierKey() {
            return ProductIdentifiers.PRODUCT_ID;
        },

        isInformationValid() {
            if (!this.name) {
                return false;
            }

            return true;
        },

        emitValidity() {
            this.$emit('validityChanged', this.isInformationValid());
        },

        populateNameAndIdentifier() {
            this.name = this.getProductName(this.product.names, this.resolveProductNameKey());
            this.id = this.getProductId(this.product.identifiers, this.resolveProductIdentifierKey());
            this.suppliersScipNumberId = this.getProductId(this.product.identifiers, ProductIdentifiers.SCIP_NUMBER);
        }
    },
    computed: {
        nameState() {
            return this.name !== undefined && this.name !== '' && this.name.length > 1;
        },

        productNameLabel() {
            return this.getNameLabel(this.resolveProductNameKey());
        },

        productIdLabel() {
            return this.getIdentifierLabel(this.resolveProductIdentifierKey());
        },

        productType() {
            return this.product.type;
        },
        suppliersScipNumberLabel() {
            return this.getIdentifierLabel(ProductIdentifiers.SCIP_NUMBER);
        },
    },

    watch: {
        productType() {
            this.populateNameAndIdentifier();
        },
        product(p) {
            this.type = this.product.type;

            this.populateNameAndIdentifier();
            this.emitValidity();
        },
        request() {
            this.emitValidity();
        }
    }
}
</script>
